var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSubscript = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.809 9.5 1.956 2h2.382L8 7.66 11.662 2h2.382L9.191 9.5l4.853 7.5h-2.382L8 11.34 4.338 17H1.956zm10.66 5.72L15 17.69V19h5v-1.5h-2.69l1.22-1.22c.77-.77 1.47-1.709 1.47-2.78 0-.525-.171-1.137-.576-1.631C19 11.35 18.35 11 17.5 11c-.85 0-1.5.35-1.924.869A2.614 2.614 0 0 0 15 13.5h1.5c0-.225.079-.488.237-.681.138-.17.363-.319.763-.319s.625.15.763.319c.158.193.237.456.237.681 0 .429-.3.99-1.03 1.72",
  clipRule: "evenodd"
})));
export default SvgSubscript;